import React from "react"
import styles from "./ResponseComments.module.scss"
import type { FeedCommentResponse } from "../../../types/feed.ts"

const DEFAULT_PROFILE_IMAGE =
  "https://edify-files-dev.s3.amazonaws.com/profile-pictures/ebba9aa8-4346-4662-b3e5-8699015659ba-image-profile-default.png"

interface ResponseCommentsProps {
  commentResponses: FeedCommentResponse[]
  calcularDiferenciaTiempo: (fechaCreacion: string) => string
  isHovered: boolean
}

const ResponseComments: React.FC<ResponseCommentsProps> = ({
  commentResponses,
  calcularDiferenciaTiempo,
  isHovered,
}) => {
  return (
    <div className={styles.response}>
      {commentResponses.map((response, index) => {
        const responseCompleteName =
          response?.user?.type === "COMPANY"
            ? response?.user?.razon_social ?? ""
            : `${response?.user?.name ?? ""} ${response?.user?.last_name ?? ""}`.trim()
        const responseImageProfile = response?.user?.image_profile
        const responseContent = response?.content
        const responseCreation = response?.createdAt ?? ""
        const responseIntials = responseCompleteName
          ?.split(" ")
          .map((n) => n[0])
          .join("")
        const responseProfileImageError =
          response?.user?.image_profile === DEFAULT_PROFILE_IMAGE
        return (
          <div className={styles.response_item} key={index}>
            <div className={styles.response_item_imgContainer}>
              {!responseProfileImageError && responseImageProfile ? (
                <img
                  className={styles.response_item_imgContainer_img}
                  src={responseImageProfile}
                  alt="user"
                />
              ) : (
                <div className={styles.response_item_imgContainer_initials}>
                  {responseIntials}
                </div>
              )}
            </div>
            <div className={styles.response_item_contentContainer}>
              <div
                className={`${styles.response_item_content} ${isHovered ? styles.response_item_content_hovered : ""}`}
              >
                <div className={styles.response_item_content_header}>
                  <div className={styles.response_item_content_header_name}>
                    {responseCompleteName}
                    <span className={styles.response_item_content_header_time}>
                      {calcularDiferenciaTiempo(responseCreation)}
                    </span>
                  </div>
                </div>
                <div className={styles.response_item_text}>{responseContent}</div>
              </div>
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default ResponseComments
